
export default function Philosophy() {
  return (
    <section id="philosophy" className="relative bg-gradient-to-b from-black to-[#0A0A0A] py-16 sm:py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1100px] mx-auto text-center">
          <div className="text-[8px] sm:text-[9px] md:text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.25em] text-[#707070] font-light mb-6 sm:mb-8">
            Philosophy
          </div>
          
          <h2 className="text-[28px] sm:text-[36px] md:text-[48px] font-light leading-[1.3] sm:leading-[1.4] text-[#F5F5F5] mb-8 sm:mb-10 md:mb-12 font-serif">
            Reliability is the ultimate luxury.
          </h2>
          
          <div className="space-y-6 sm:space-y-8 text-sm sm:text-base md:text-lg font-light text-[#9A9A9A] leading-relaxed px-4 sm:px-0">
            <p>
              In your world, seconds matter. Whether it's your flight crew at 30,000 feet, 
              miles away into the sea, or your estate staff at home—the gap between a crisis 
              and a recovery is found in those around you.
            </p>
            
            <p className="text-base sm:text-lg md:text-xl text-[#C0C0C0]">
              Let's face it: prevention is better than cure.
            </p>
            
            <p>
              Empower those around you to be your first doctors.
            </p>
          </div>

          <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              { number: '30K', label: 'Feet Above Ground', desc: 'CABIN CREW READINESS' },
              { number: 'Miles', label: 'Into Open Waters', desc: 'MARITIME CREW READINESS' },
              { number: 'Seconds', label: 'Response Window', desc: 'ESTATE STAFF READINESS' }
            ].map((item, index) => (
              <div
                key={index}
                className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8 hover:border-[#D4C4B0]/30 transition-all duration-500"
              >
                <div className="text-[28px] sm:text-[36px] md:text-[42px] font-bold text-[#D4C4B0] mb-2 font-serif">
                  {item.number}
                </div>
                <div className="text-sm sm:text-[14px] text-[#F5F5F5] mb-2">
                  {item.label}
                </div>
                <div className="text-[9px] sm:text-[10px] md:text-[11px] uppercase tracking-[0.15em] text-[#606060]">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
